import Service from "./Service";
import {connect} from "react-redux";
import { getServiceDetail } from "../../../redux/actions/newService/serviceDetail.actions";
import { clearDemandComments, getComments } from "../../../redux/actions/newService/comment.actions";
import { openCommentForm,closeCommentForm } from "../../../redux/actions/newService/comment.actions";
import { downloadFiles } from "../../../redux/actions/fileAttachment/fileAttachment.actions";
import { openServiceStatusForm } from "../../../redux/actions/newService/serviceStatus.actions";
import { openNewServiceForm } from "../../../redux/actions/newService/service.actions";
import { showAlertPopup } from "../../../redux/actions/AlertErrorMessage/alertErrorMessage.action";
import { ReadNotification } from "../../../redux/actions/notification/getEventNotificationList.action";



const mapStateToProps = (state) => {
    return {
      servicesDetail: state.newService.serviceDetail.serviceDetail,
      isLoading:state.newService.serviceDetail.loading,
      next: state.newService.comment?.next,
      comments: state.newService.comment.comments,
      isCommentFormOpen:state.newService.comment.isCommentFormOpen,
      isCommentsLoading:state.newService.comment.isLoading,
      myRights:state.myRights.myRights,
    }
  }

  const mapDispatchToProps = (dispatch)=>{
    return {        
        getServiceDetail: (requestId)=>{
            return dispatch(getServiceDetail(requestId))
        },       
        getComments:(requestId,next=null)=>{
          return dispatch(getComments(requestId,next))
        },
        openCommentForm : () => {
          return dispatch(openCommentForm())
      },
      closeCommentForm: () => {
          return dispatch(closeCommentForm())
      },
      downloadFile:(originalFileName,uniqueFileName)=>{
        return dispatch(downloadFiles(originalFileName,uniqueFileName))
      },
      openServiceStatusForm : () => {
        return dispatch(openServiceStatusForm())
      },
      clearDemandComments:()=>{
        return dispatch(clearDemandComments())
    },
        openNewServiceForm: (payload) => {
              return dispatch(openNewServiceForm(payload))
          },
          showAlertPopup: (alertHeader,alertmessage) => {
            return dispatch(showAlertPopup(alertHeader,alertmessage))
          },
          ReadNotification: (payload,id) => {
            return dispatch(ReadNotification(payload,id))
        }
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(Service);


